import {ChangeDetectionStrategy, Component, effect, input, signal, viewChild} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {GruppeLogoKomponent} from "../gruppe-logo/gruppe-logo";
import {Autentiseringsmetode, GruppeId} from "../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {medlemmerMedTilgangMedBrukertilknytning, medlemmerMedTilgangUtenBrukertilknytning} from "../../../../../felles-ng2/modell/medlemModellHjelpere";
import {erNil} from "../../../../../felles-ng2/støttefunksjoner/nilsjekk";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {lavesteAutentiseringsmetode} from "web-ng2/moduler/gruppe/komponenter/grupper-list-maler/grupper-list-maler";
import {EnumOversettelser} from "felles-ng2/tjenester/i18n/EnumOversettelser";
import {MatTooltip} from "@angular/material/tooltip";
import {GruppeNyKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-ny/gruppe-ny";

const debug = initDebugger('GrupperListOrdinaereKomponent');

@Component({
    selector: 'grupper-list-ordinaere',
    templateUrl: 'grupper-list-ordinaere.html',
    styleUrl: 'grupper-list-ordinaere.scss',
    imports: [
        TranslateModule,
        MatTable,
        MatColumnDef,
        MatHeaderCell,
        MatCell,
        MatHeaderCellDef,
        MatCellDef,
        MatHeaderRow,
        MatRow,
        MatRowDef,
        MatHeaderRowDef,
        GruppeLogoKomponent,
        ReactiveFormsModule,
        MatSort,
        MatTableModule, MatSortModule, GruppeLogoKomponent, MatButton, MatIcon, MatTooltip, GruppeNyKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperListOrdinaereKomponent {
    static ajsSelector = 'grupperListOrdinaere';

    ordinaere = input<GruppeModell[]>([]);
    ordinaereDataSource: MatTableDataSource<GruppeModell> = new MatTableDataSource<GruppeModell>();
    ordinaereSort = viewChild(MatSort);

    viserOpprettGruppeSkjema = signal(false);


    constructor(private navigasjon:Navigasjon, private enumOversettelser: EnumOversettelser) {

        effect(() => {
            this.ordinaereDataSource.data = this.ordinaere();
        });

        effect(() => {
            const sortInstance = this.ordinaereSort();
            this.ordinaereDataSource.sortingDataAccessor = (item: GruppeModell, property: string) => {
                switch (property) {
                    case 'antMedlemmer':
                        return this.antallAktiveMedlemmerIGruppe(item);

                    case 'antInviterte':
                        return this.antallInvitasjonerIGruppe(item);

                    case 'antmoeter':
                        return item.antallMoeterInnevaerendeAar;

                    case 'innlogging':
                        return lavesteAutentiseringsmetode(item.tillatteAutentiseringsmetoder);

                  // For alle andre kolonner (som 'id'), bruk standard oppførsel
                    default:
                        return (item as any)[property];
                }
            };

            // 3. Koble til sort-instansen ETTER at sortingDataAccessor er definert

            if (sortInstance) {
                this.ordinaereDataSource.sort = sortInstance;
            }
        });
    }

    opprettGruppe() {
        this.viserOpprettGruppeSkjema.set(true);
    }

    vedAvbryt(){
        this.viserOpprettGruppeSkjema.set(false);
    }

    nyGruppeOpprettet(nyGruppe: GruppeModell) {
        this.viserOpprettGruppeSkjema.set(false);
        //kalle async varianten da vi ellers får problemer fordi NavigasjonDeaktivering.reaktiverNavigasjon kjører asynkront
        this.navigasjon.gåTilGruppeAsync(nyGruppe.id);
    }


    antallAktiveMedlemmerIGruppe(gruppe: GruppeModell): number {
        if (erNil(gruppe)) return 0;
        return medlemmerMedTilgangMedBrukertilknytning(gruppe.alleMedlemmer).length
    }

    antallInvitasjonerIGruppe(gruppe: GruppeModell): number {
        if (erNil(gruppe)) return 0;
        return medlemmerMedTilgangUtenBrukertilknytning(gruppe.alleMedlemmer).length
    }

    autentiseringsmetoder(gruppe: GruppeModell): string[] {
        if (erNil(gruppe)) return [];
        return gruppe.tillatteAutentiseringsmetoder.map(metode => this.autentiseringsmetodeTekst(metode));
    }

    gaaTilGruppe(gruppeId: GruppeId) {
        this.navigasjon.gåTilGruppe(gruppeId);
    }

    visVarselForAutentiseringsmetode(gruppe: GruppeModell): boolean {
        let laveste = lavesteAutentiseringsmetode(gruppe.tillatteAutentiseringsmetoder);
        return laveste === Autentiseringsmetode.passord;
    }

    lavesteAutentiseringsmetodeTekst(gruppe: GruppeModell): string {
        let laveste = lavesteAutentiseringsmetode(gruppe.tillatteAutentiseringsmetoder);
        if (!erNil(laveste)) return this.autentiseringsmetodeTekst(laveste);
        return ''; // bør ikke skje
    }


    private autentiseringsmetodeTekst(metode: Autentiseringsmetode): string {
        return this.enumOversettelser.oversettetAutentiseringsmetode(metode);
    }

}
